import React from 'react';
import { CustomSVG } from '../../CustomSVG/CustomSVG';
import OpenShiftSVG from '../../../assets/icons/clouds/openshift.svg?raw';

export const OpenShiftLogo = (props) => <CustomSVG svg={OpenShiftSVG} preserveColors {...props} />;
